import React, { useContext, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getRegistrationInfo } from "../../context/registrationContext/RegistrationApiCalls";
import { RegistrationContext } from "../../context/registrationContext/RegistrationContext";

const RegisterInfo = () => {
  const { userId } = useParams();
  const { token } = useParams();
  const navigate = useNavigate();
  const { registrationInfo, isFetching, error, dispatch } = useContext(RegistrationContext);

  useEffect(() => {
    getRegistrationInfo(userId, token, dispatch);
  }, [userId, token, dispatch]);

	if (!isFetching && registrationInfo) {
    navigate("/register/" + userId);
  }

	if(!isFetching && error){
    navigate("/login");
	}

	return <div>loading...</div>;
}

export default RegisterInfo;